import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';
import { TEAM } from '../../../../../packages/constants/widgetIds';

export const teamAttributes = getWidgetAttributes(
  TEAM,
  [WidgetAttributes.WIDGET_SPORT, WidgetAttributes.WIDGET_TYPE, WidgetAttributes.WIDGET_ID, WidgetAttributes.TEAM, WidgetAttributes.SEASON],
  [
    WidgetAttributes.NAME_TYPE,
    WidgetAttributes.THEME,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.MATCH,
    WidgetAttributes.LABELS,
    WidgetAttributes.ELEMENTS,
    WidgetAttributes.ODDS_BETTING_ID,
    WidgetAttributes.ODDS_DISPLAY,
    WidgetAttributes.ODDS_MARKET,
    WidgetAttributes.ODDS_PRE_EVENT_ONLY,
    WidgetAttributes.ODDS_MARKET_VALUE_TYPE,
    WidgetAttributes.DATA_MATCH_DISPLAY,
    WidgetAttributes.DATA_STATISTICS_DISPLAY,
    WidgetAttributes.DATA_DISPLAY_SOCIAL_ICONS,
    WidgetAttributes.DATA_DISPLAY_TEAM_IMAGE,
    WidgetAttributes.ALLOW_INLINE_ODDS,
    WidgetAttributes.BETTING_BRAND_COLORS,
    WidgetAttributes.BETTING_LOGO_CLICK_ACTION,
    WidgetAttributes.BETTING_LOGO_OVERLAP,
  ],
);
